// extracted by mini-css-extract-plugin
module.exports = {"cardWr":"Tags_cardWr__2JbXj","cardTitle":"Tags_cardTitle__2KoXU"};